<div [class.dark]="dark" [class.primary]="primary">
    <span (click)="changeAccordionState()">
        <div [class.primary]="primary" [@rotatedState]='state' class="arrow"></div>
        <h5>{{ title }}</h5>
    </span>
    <div class="accordion" #accordion>
        <ng-content></ng-content>
    </div>
</div>
